import React from "react";
import { Copy, Check } from "lucide-react";
import { toast } from "sonner";
import { copyToClipboard } from "@/lib/api";

export function CopyField({ value, label, testId }) {
  const [copied, setCopied] = React.useState(false);
  const onCopy = async () => {
    await copyToClipboard(value);
    setCopied(true);
    toast.success("Copied to clipboard", { description: label || undefined });
    setTimeout(() => setCopied(false), 1400);
  };
  return (
    <div className="flex items-stretch gap-2" data-testid={testId}>
      <div className="flex-1 font-mono text-xs bg-black/50 border border-white/10 rounded-md px-3 py-2 truncate">{value}</div>
      <button
        onClick={onCopy}
        data-testid={testId ? `${testId}-copy-btn` : undefined}
        className="px-3 rounded-md bg-white/5 hover:bg-white/10 border border-white/10 text-xs flex items-center gap-1"
      >
        {copied ? <Check className="w-3.5 h-3.5" /> : <Copy className="w-3.5 h-3.5" />} Copy
      </button>
    </div>
  );
}
